import { ClaudeTemplate } from "../types";

/** AdRoll: retargeting display. */
export const adrollTemplate: ClaudeTemplate = {
  id: "adroll",
  tool: "AdRoll",
  url: "https://app.adroll.com/",
  hierarchy:
    "Organización → Advertisable (cuenta) → Campaign → Ad groups (audiencia + anuncios)",
  idHint: "ID (EID) de la campaña en la URL al abrirla o en el detalle",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre AdRoll ({{url}}). Si ya está abierto, sigue.
2. Elige el advertisable / cuenta de {{client}}. Si hay varias, pregunta.
3. Comprueba que el pixel de AdRoll está instalado y activo en la web del cliente: el retargeting depende de él. Si no lo está, avísame.

### 2. Campaign de retargeting
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, créala (tipo retargeting / display):
   - Name: {{names.order}}
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}} (si solo admite diario, reparte el total entre los días y dímelo).
   - Objetivo / KPI: {{goal.kpi}}, puja en torno a {{goal.netUnitCost}}.

### 3. Ad group
1. Name: {{names.line}}
2. Audiencia: los segmentos de visitantes del sitio {{target.audience}}. Si no existen, no los crees sin preguntar. Exclusiones (p. ej. compradores): {{target.exclusions}}.
3. Geografía: {{target.geography}} (país {{goal.country}}). Dispositivos: {{target.technology}}.

### 4. Ads
1. Sube los banners del bloque "Creatividades" (todos los tamaños disponibles).
2. URL de destino con UTM: bloque "URLs de destino".
3. Deja la campaña **en pausa / sin lanzar**.
`,
};
